<template src="./index.html" />
<script>
import API from '@/services/GraphQl';
import validators from '@/helpers/validators';
export default {
  data() {
    return {
      validators,
      email: '',
      error: '',
    };
  },
  methods: {
    async onSubmit() {
      if (this.$refs.reinvitationForm.validate()) {
        try {
          this.$store.commit('spinner', true);
          await API.resetExpiredUser({
            email: this.email.toLowerCase(),
          });
          this.closeModal();
        } catch (e) {
          console.log(e);
          this.error = e.errors[0].message;
        } finally {
          this.$store.commit('spinner', false);
        }
      }
    },
    closeModal() {
      this.$refs.reinvitationForm.reset();
      this.$store.commit('showModalAction', 'isReinviteModalOpened');
    },
  },
};
</script>
